export default [
  {
    path: '/pessoal/pesdesempenho', name: 'pesdesempenho', description: 'Prova de Desempenho',
    component: () => import('@/views/pessoal/pesdesempenho/Index.vue'), goesToMenu: true,
  },
];
